export default {
  primary: {
    main: "#9775AA",
    darker: "#774E90",
  },
  gradient: {
    main:
      "linear-gradient(171deg, rgba(192,16,246,1) 0%, rgba(55,6,213,1) 100%)",
  },
  secondary: {
    main: "#CD88AF",
    darker: "#AE5889",
  },
  text: {
    primary: "#fff",
    secondary: "#707070",
  },
  background: {
    default: "#261758",
    secondary: "rgb(239, 239, 239)",
    paper: "#fff",
    dark: "rgb(1, 0, 48)",
  },
  dark: {
    main: "#262262",
    secondary: "#18153d",
  },
  divider: "#DBDBDB",
};
